import * as React from 'react'
import { VoiceSampleList } from '../VoiceSampleList'
import Button from 'components/Button'
import cn from 'classnames'
import * as sLay from 'styles/modules/layout.scss'
import { InjectedFormProps } from 'redux-form'
import * as sMarg from 'styles/modules/margins.scss'
import * as sText from 'components/Text/Text.scss'

export interface IVoiceCreateActorStepProps {
  prev: () => void
  change: InjectedFormProps['change']
  formData: any
  setHeadings?: Function
}

export class VoiceCreateActorStep extends React.Component<IVoiceCreateActorStepProps> {
  render() {
    const { prev, change, formData, setHeadings } = this.props

    setHeadings &&
      setHeadings({
        heading: 'Give your callers something worth listening to.',
        subHeading:
          'Select a voice that works for you from our selection of our Simply Awesome Voice Artists.',
      })

    return (
      <div>
        <div className={cn(sText.descrip3, sMarg.mb30)}>
          Each of the Professional Voice Artists comes with their costs as indicated next to their
          voice sample. (Prices are based on 100 x words or approx 1 min scripts) Once you have
          completed entering your voice scripts, we will provide you with a detailed quote for your
          approval. The cost for the recording will be added to your Pickle preferred billing
          account.
        </div>
        <VoiceSampleList
          talendID={formData.talentID}
          filter={formData.filter}
          onSelect={sample => change('talentID', sample.talentID)}
        />
        <div
          className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}
          style={{ marginTop: '40px' }}
        >
          <Button plain onClick={prev}>
            Back
          </Button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/features/Voices/VoiceCreateActorStep/VoiceCreateActorStep.tsx